import { useState } from "react";
import { BroadcastChannel } from "broadcast-channel";
import { createChannel } from "./createChannel";

export const useGetChannelMessage = <T>(channelName: string) => {
  const [message, setMessage] = useState<T>();
  const channel: BroadcastChannel<T> = createChannel(channelName);

  channel.onmessage = (msg: T) => {
    setMessage(msg);
  };

  return message;
};
